import { Reducer } from 'redux';
import { update } from '../../helpers/immutabilityHelper'
import * as Dtos from '../../dtos/Tmd.dtos';

import {
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEWDATAENTRY_PAGE_SET_UPDATE_MODAL_STATE
} from '../../actions/pages/trialInstitutionItemCustomViewDataEntryPage';


export interface ITrialInstitutionItemCustomViewDataEntryPageState {
    updateModalOpen: boolean;
    updateModalCustomDataEntryColumn: Dtos.CustomDataEntryColumn;
    updateModalCollectionInstanceData: Dtos.CollectionInstanceData;
}

const initialState: ITrialInstitutionItemCustomViewDataEntryPageState = {
    updateModalOpen: false,
    updateModalCustomDataEntryColumn: null,
    updateModalCollectionInstanceData: null
};


function setUpdateModalViewState(state: ITrialInstitutionItemCustomViewDataEntryPageState, updateModalOpen: boolean, updateModalCustomDataEntryColumn: Dtos.CustomDataEntryColumn, updateModalCollectionInstanceData: Dtos.CollectionInstanceData): ITrialInstitutionItemCustomViewDataEntryPageState {
    const newState: ITrialInstitutionItemCustomViewDataEntryPageState = update(state, {
        updateModalOpen: {
            $set: updateModalOpen
        },
        updateModalCustomDataEntryColumn: {
            $set: updateModalCustomDataEntryColumn
        },
        updateModalCollectionInstanceData: {
            $set: updateModalCollectionInstanceData
        }
    });
    return newState;
}

const TrialInstitutionItemsPageReducer: Reducer<ITrialInstitutionItemCustomViewDataEntryPageState> = (state: ITrialInstitutionItemCustomViewDataEntryPageState = initialState, action) => { 
    switch (action.type) {
        case ACTION_TRIALINSTITUTIONITEMCUSTOMVIEWDATAENTRY_PAGE_SET_UPDATE_MODAL_STATE:
            return setUpdateModalViewState(state, action.updateModalOpen, action.updateModalCustomDataEntryColumn, action.updateModalCollectionInstanceData);
    }

    return state;
}

export default TrialInstitutionItemsPageReducer;